export default __webpack_public_path__ + "static/media/map.a2b88403.png";